const defaultTooltip = {
    AmountOwe: 'current-balance',
    AmountOwed: 'amount-owed',
    AmountOwedOnTrade: 'amount-owed-on-trade',
    AnnualIncome: 'annual-income',
    AnnualInterestRate: 'annual-interest-rate',
    APR: 'apr',
    BalanceTransferSaving: 'dma-balance-transfer-card-savings',
    CarAnnualPercentageRate: 'car-annual-percentage-rate',
    CarDownPayment: 'car-down-payment',
    CompoundInterval: 'compound-interval',
    CreditCardDebt: 'dma-credit-card-debt',
    CreditCardOption: 'dma-credit-card-option',
    CreditScore: 'credit-score',
    CurrentAppraisedValue: 'appraisal',
    CurrentCreditScore: '4cs-of-creditworthiness',
    DebtCovered: 'dma-debt-covered',
    DebtNotCovered: 'dma-debt-not-covered',
    DebtSettlementOption: 'dma-debt-settlement-option',
    DebtSettlementSaving: 'dma-debt-settlement-savings',
    DebtToIncomeRatioDti: 'debt-to-income-ratio-dti',
    DownPayment: 'down-payment',
    ExistingLoanInformation: 'existing-loan-information',
    FhaDownPayment: 'fha-down-payment',
    HomeBased: 'home-based',
    HomeEquityOption: 'dma-home-equity-option',
    HomeEquitySaving: 'dma-home-equity-savings',
    HomePrice: 'home-price',
    HomeVal: 'home-value',
    InitialSavings: 'initial-savings',
    Interest: 'dma-interest',
    InterestRate: 'interest-rate',
    LastMonthsDeposits: 'last-months-deposits',
    LoanAmount: 'loan-amount',
    LoanTerm: 'loan-terms',
    LoanType: 'loan-terms',
    MedicalExpenses: 'dma-medical-expenses',
    MonthlyExpenses: 'monthly-debt',
    MonthlyPayment: 'dma-monthly-payment',
    Mortgage: 'mortgage',
    NetTradeValue: 'net-trade-in-value',
    OtherDebt: 'dma-other-debt',
    PersonalLoanOption: 'dma-personal-loan-option',
    PersonalLoans: 'dma-personal-loans',
    PersonalLoanSaving: 'dma-personal-loan-savings',
    PrivateMortgageInsurance: 'private-mortgage-insurance',
    RateOfReturn: 'rate-of-return',
    RetirementAge: 'retirement-age',
    SalesTax: 'sales-tax-percentage',
    TaxesFees: 'taxes-fees',
    Title: 'title',
    TotalInterest: 'total-interest',
    TotalLoanAmount: 'total-loan-amount',
    TotalLoanRepayment: 'total-loan-repayment',
    TotalOfAllPayment: 'total-of-all-payments',
    TradeInValue: 'trade-in-value',
    VaDownPayment: 'down-payment',
};

export default defaultTooltip;
